import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="not-found-page">
      <div className="text-center max-w-md px-4">
        <div className="overline mb-3">404</div>
        <h1 className="font-heading font-extrabold text-4xl lg:text-5xl tracking-tight">Page not found</h1>
        <p className="text-msr-slate mt-3">The page you requested doesn't exist or has moved.</p>
        <Link to="/" className="btn-msr-primary mt-7">Back to Home</Link>
      </div>
    </div>
  );
}
